import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { closeModal } from '../../_shared/modal/modalActions';

const DuplicateFirmConfirmationContent = ({ message, proceedAction, onCloseModal, onProceed }) => {

  const handleNo = () => {
    onCloseModal();
  };

  const handleYes = () => {
    onProceed(proceedAction);
  };

  return (
    <>
      <DialogTitle id="duplicate-firm-dialog-title">Duplicate Firm</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleNo} color="primary" variant="outlined">
          No
        </Button>
        <Button onClick={handleYes} color="primary" variant="contained" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </>
  );
};

DuplicateFirmConfirmationContent.propTypes = {
  message: PropTypes.string.isRequired,
  proceedAction: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  onCloseModal: () => dispatch(closeModal()),
  onProceed: action => {
    dispatch(closeModal());
    dispatch(action);
  },
});

export default connect(null, mapDispatchToProps)(DuplicateFirmConfirmationContent);
